import { CopyToClipboard } from "react-copy-to-clipboard";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const Footer = () => {
  const [text, setText] = useState("GOODHEALTH");

  const [isCopied, setIsCopied] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="best">
      <section>
        <div className="container">
          <div className="kout">
            <div className="chec">
              <img src="/images/Vector1.png" alt="" />
              <h3>Try us at a special price, use code on checkout.</h3>
              <div className="good">
                <CopyToClipboard
                  text={text}
                  onCopy={() => {
                    setIsCopied(true);
                    setTimeout(() => {
                      setIsCopied(false);
                      setText("GOODHEALTH");
                    }, 1000);
                  }}
                >
                  <h2
                    value={text}
                    onChange={({ target }) => {
                      setText(target.value);
                    }}
                    onClick={() => {
                      setText("copied");
                    }}
                  >
                    {isCopied == false && <span>{text}</span>}
                    {isCopied ? (
                      <span className="success-msg"> {text}</span>
                    ) : null}
                    <i className="fa-solid fa-file"></i>
                  </h2>
                </CopyToClipboard>
              </div>
            </div>
            <div className="speci">
              <div className="join">
                <div className="row">
                  <div className="col-md-7">
                    <div className="space">
                      <h3>
                        Stay tuned with us for health tips, product information
                        and New Launches.
                      </h3>
                      <button>
                        <i className="fa-regular fa-envelope"></i> <b>JOIN OUR
                        NEWSLETTER</b>
                      </button>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="ellipse">
                      <img src="/images/Capture.PNG" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              {/*<div className="icon">
                       <div className="facebook">  <img src={'/images/icon/Facebook.png'}/></div>
                 <div className="facebook">  <img src={'/images/icon/Twitter.png'}/></div>
				 <div className="facebook">  <img src={'/images/icon/Instagram.png'}/></div>
				 <div className="facebook">  <img src={'/images/icon/Pinterest.png'}/></div>
				 <div className="facebook">  <img src={'/images/icon/Youtube.png'}/></div>
				 <div className="facebook">  <img src={'/images/icon/Linked.png'}/></div>
                  
                    </div>*/}

              <div
                style={{
                  display: "flex",
                  paddingBottom: "10px",
                  paddingLeft: "120px",
                  marginTop: "-27px",
                  justifyContent: "space-between",
                  backgroundColor: "white",
                  alignItems: "end",
                }}
              >
                <div className="links" style={{ zIndex: "99" }}>
                  <a href="#" style={{ marginLeft: "10px" }}>
                    <img
                      style={{
                        width: "40px",
                        border: "4px solid #fff",
                        borderRadius: "50%",
                        padding: "0",
                        boxShadow: "0px 3px 3px -1px",
                        color: "#000",
                      }}
                      src="/images/facebook1.png"
                      alt=""
                    />
                  </a>
                  <a href="#" style={{ marginLeft: "10px" }}>
                    <img
                      style={{
                        width: "40px",
                        border: "4px solid #fff",
                        borderRadius: "50%",
                        padding: "0",
                        boxShadow: "0px 3px 3px -1px",
                        color: "#000",
                      }}
                      src="/images/twtter.png"
                      alt=""
                    />
                  </a>
                  <a href="#" style={{ marginLeft: "10px" }}>
                    <img
                      style={{
                        width: "40px",
                        border: "4px solid #fff",
                        borderRadius: "50%",
                        padding: "0",
                        boxShadow: "0px 3px 3px -1px",
                        color: "#000",
                      }}
                      src="/images/instagram.png"
                      alt=""
                    />
                  </a>
                  <a href="#" style={{ marginLeft: "10px" }}>
                    <img
                      style={{
                        width: "40px",
                        border: "4px solid #fff",
                        borderRadius: "50%",
                        padding: "0",
                        boxShadow: "0px 3px 3px -1px",
                        color: "#000",
                      }}
                      src="/images/Pinterest.png"
                      alt=""
                    />
                  </a>
                  <a href="#" style={{ marginLeft: "10px" }}>
                    <img
                      style={{
                        width: "40px",
                        border: "4px solid #fff",
                        borderRadius: "50%",
                        padding: "0",
                        boxShadow: "0px 3px 3px -1px",
                        color: "#000",
                      }}
                      src="/images/youtube.png"
                      alt=""
                    />
                  </a>
                  <a href="#" style={{ marginLeft: "10px" }}>
                    <img
                      style={{
                        width: "40px",
                        border: "4px solid #fff",
                        borderRadius: "50%",
                        padding: "0",
                        boxShadow: "0px 3px 3px -1px",
                        color: "#000",
                      }}
                      src="/images/linkedin.png"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="chec1">
              <img src="/images/Vector1.png" alt="" />
              <h3>Try us at a special price, use code on checkout.</h3>
              <div className="good">
                <h2>
                  GOODHEALTH <i className="fa-solid fa-file"></i>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer>
        <div className="container">
          <div className="row">
            {" "}
            <div className="nutra col-md-3 "></div>
            <div className="nutra col-md-2 ">
              <h5>ZeoNutra</h5>
              <p
                onClick={() => {
                  navigate("/contactus");
                }}
              >
                Contact Us
              </p>
              <p
                onClick={() => {
                  navigate("/404");
                }}
              >
                Blogs
              </p>
              <p
                onClick={() => {
                  navigate("/404");
                }}
              >
                Press
              </p>
              <p
                onClick={() => {
                  navigate("/404");
                }}
              >
                FAQs
              </p>
              <p
                onClick={() => {
                  navigate("/dashboard");
                }}
              >
                My Account
              </p>
              <p
                onClick={() => {
                  navigate("/404");
                }}
              >
                Site Map
              </p>
            </div>
            <div className="nutra col-md-2 ">
              <h5>Why ZeoNutra?</h5>
              <p
                onClick={() => {
                  navigate("/404");
                }}
              >
                Our Mission
              </p>
              <p
                onClick={() => {
                  navigate("/ingredents");
                }}
              >
                Our Ingredients
              </p>
              <p
                onClick={() => {
                  navigate("/404");
                }}
              >
                Our Experts
              </p>
              <p
                onClick={() => {
                  navigate("/aboutus");
                }}
              >
                About Us
              </p>
            </div>
            <div className="nutra col-md-2 ">
              <h5>Also available on</h5>
              <p>Amazon</p>
              <p>Dhani</p>
              <p>First Cry</p>
              <p>Flipkart</p>
              <p>Healthkart</p>
              <p>Local Options</p>
              <p>Meesho</p>
              <p>Netmeds</p>
              <p>Pharmacy</p>
              <p>Pharmeasy</p>
              <p>Tata 1mg</p>
            </div>
          </div>
        </div>
      </footer>

      <footer>
        <div className="footer2">
          <div className="neonutra2">
            <h5>ZeoNutra</h5>
            <h6>
              Contact Us <span className="our_experts6">faq</span>
              <br />
              Blogs <span className="our_experts7">My Account</span>
              <br />
              Press <span className="our_experts8">Site Map</span>
            </h6>
          </div>
          <div className="neonutra2">
            <h5>Why ZeoNutra?</h5>
            <h6>
              Our Mission <span className="our_experts9">Our Experts</span>{" "}
              <span>Our Ingredients </span>
              <span className="our_experts1">About Us</span>
            </h6>
          </div>
          <div className="neonutra2">
            <h5>Also available on</h5>
            <h6>
              Amazon <span className="our_experts">Meesho </span>
              <br /> Dhani <span className="our_experts2">
                Netmeds{" "}
              </span> <br /> First Cry{" "}
              <span className="our_experts3">Pharmacy </span> <br /> Flipkart{" "}
              <span className="our_experts4">Pharmeasy </span> <br /> Healthkart{" "}
              <span className="our_experts5">Tata 1mg </span> <br />
              Local Options <span className="our_experts2"> </span>{" "}
            </h6>
          </div>
        </div>
      </footer>
      <div className="speci">
        <div className="icon1">
          <div className="facebook">
            {" "}
            <i className="fa-brands fa-facebook-f"></i>
          </div>
          <div className="twitter">
            <i className="fa-brands fa-twitter"></i>
          </div>
          <div className="instagram">
            <i className="fa-brands fa-instagram"></i>
          </div>
          <div className="pinterest">
            <i className="fa-brands fa-pinterest-p"></i>
          </div>
          <div className="youtube">
            <i className="fa-brands fa-youtube"></i>
          </div>
          <div className="linkedin">
            <i className="fa-brands fa-linkedin-in"></i>
          </div>
        </div>
      </div>
      <div className="zeon">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h5 className="global1">© Zeon Global Nutritions Pvt. Ltd.</h5>
              <h5 className="global">
                ZeoNutra by Zeon Global Nutritions Pvt. Ltd. ©
              </h5>
            </div>
            <div className="col-md-6">
              <div className="policy">
                <a href="#">Privacy Policy</a>
                <a href="#">Terms of Services</a>
                <a href="#" className="refund-Policy">
                  Refund Policy
                </a>
                <a href="#" className="refund-Policy">
                  Shipping Policy
                </a>
                <a href="#" className="refund-Policy">
                  Pricing Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="paytmcard">
        <img src="/images/framee.png" alt="" />
      </div>
    </div>
  );
};

export default Footer;
